'use client'

// https://www.remotion.dev/docs/google-fonts/get-available-fonts
import { getAvailableFonts } from '@remotion/google-fonts';

const fonts = [
    "Inter",
    "Titan One",
    "Merriweather",
    "Roboto Mono",
    "VT323",
    "Poppins",
    "Montserrat",
    "Lato",
    "Oswald",
    "Raleway",
    "Lora",
    "ubuntu",
    "Loved by the King",
    "Love Light",
    "Lovers Quarrel",
    "Space Grotesk",
    "Rubik Mono One",
    "Playfair Display",
    "Plus Jakarta Sans",
    "Space Grotesk",
    "Dancing Script",
    "Noto Sans Georgian",
    "Patrick Hand",
    "Courier Prime",
    "Noto Sans",
    "Orbitron",
    "Great Vibes",
];

const selectedFonts = 
    getAvailableFonts()
    .filter((f)=>fonts.includes(f.fontFamily));

export const preloadFonts = async () => {
    await Promise.all(selectedFonts.map(async (font) => {
        const load = await font.load();
        await load.loadFont();
    }));
}
preloadFonts();

export const getFontFamilies = ()=>{
    return selectedFonts;
}

